import { AbstractService } from '@uniqoders/sdk';

export default class ContactMessageService extends AbstractService {
  public listCmsContactMessages(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/contact-messages', { agency }),
      params,
    });
  }

  public getCmsContactMessage(agency: string, messageId: number): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/contact-messages/{messageId}', { agency, messageId }),
    });
  }

  public updateCmsContactMessageStatus(
    agency: string,
    messageId: number,
    status: 'new' | 'read' | 'archived',
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/contact-messages/{messageId}/status', {
        agency,
        messageId,
      }),
      data: { status },
    });
  }

  public deleteCmsContactMessage(agency: string, messageId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/contact-messages/{messageId}', { agency, messageId }),
    });
  }
}
